module.exports = __webpack_public_path__ + "img/txt_info2.1e1b4ffb.png";